import type { NPCConfig } from '@/entities';
import V2EndingNodes from "@/config/NPCConfigs/v2/V2EndingNodes";

const secretEndingNodes = V2EndingNodes.SECRET_ENDING

const config: NPCConfig[] = [
  {
    x: 2100,
    y: 1700,
    name: 'SECRET',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'secret_1',
      nodes: secretEndingNodes
    },
  },

  {
    x: 2100,
    y: 1200,
    name: 'ELSA DEAD\nFAIL END',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'efed_1',
      nodes: V2EndingNodes.ELSA_FAIL_DEFEND_ENDING,
    },
  },
  {
    x: 2250,
    y: 1200,
    name: 'ELSA DEAD\nWRONG END',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'ewe_1',
      nodes: V2EndingNodes.ELSA_WRONG_ENDING,
    },
  },
  {
    x: 2400,
    y: 1200,
    name: 'BUNGA DEAD\nWRONG END',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'bwe_1',
      nodes: V2EndingNodes.BUNGA_WRONG_ENDING,
    },
  },

  {
    x: 2100,
    y: 1350,
    name: 'HOLGA DEAD\nWRONG END',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'hwe_1',
      nodes: V2EndingNodes.HOLGA_WRONG_ENDING,
    },
  },

  {
    x: 2350,
    y: 1350,
    name: 'SELF DEAD',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'sde_1',
      nodes: V2EndingNodes.SELF_DEATH_ENDING,
    },
  },



  // {
  //   x: 1700,
  //   y: 1600,
  //   name: 'SECRET 2',
  //   color: 0x9932cc, // Dark orchid
  //   spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
  //   dialogTree: {
  //     startDialogId: 'secret_1',
  //     nodes: {
  //       secret_1: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/backdrop/stake_empty.ktx2',
  //         nextDialogId: "secret_2",
  //         cinematic: true,
  //       },
  //       secret_2: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/stake_yanf.ktx2',
  //         nextDialogId: "secret_3",
  //         cinematic: true,
  //       },
  //       secret_3: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
  //         nextDialogId: "secret_4",
  //         cinematic: true,
  //       },
  //       secret_4: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: `Yan dibakar hidup-hidup oleh orang-orang desa`,
  //         backgroundImage: '/assets/backdrop/stake_on_fire.ktx2',
  //         nextDialogId: "secret_5",
  //         cinematic: true,
  //       },
  //       secret_5: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/black.ktx2',
  //         nextDialogId: "secret_b1",
  //         cinematic: true,
  //       },
  //
  //       secret_b1: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b1.ktx2',
  //         nextDialogId: "secret_b2",
  //         cinematic: true,
  //       },
  //       secret_b2: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b2.ktx2',
  //         nextDialogId: "secret_b3",
  //         cinematic: true,
  //       },
  //       secret_b3: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b3.ktx2',
  //         nextDialogId: "secret_b4",
  //         cinematic: true,
  //       },
  //       secret_b4: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b4.ktx2',
  //         nextDialogId: "secret_b5",
  //         cinematic: true,
  //       },
  //       secret_b5: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b5.ktx2',
  //         nextDialogId: "secret_b6",
  //         cinematic: true,
  //       },
  //       secret_b6: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b6.ktx2',
  //         nextDialogId: "secret_b7",
  //         cinematic: true,
  //       },
  //       secret_b7: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b7.ktx2',
  //         nextDialogId: "secret_b8",
  //         cinematic: true,
  //       },
  //       secret_b8: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b8.ktx2',
  //         nextDialogId: "secret_b9",
  //         cinematic: true,
  //       },
  //       secret_b9: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b9.ktx2',
  //         nextDialogId: "secret_b10",
  //         cinematic: true,
  //       },
  //       secret_b10: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/secret_b10.ktx2',
  //         nextDialogId: "secret_b11",
  //         cinematic: true,
  //       },
  //       secret_b11: {
  //         id: 'secret_1',
  //         speaker: '',
  //         text: ``,
  //         fade: true,
  //         backgroundImage: '/assets/cutscene/black.ktx2',
  //         nextDialogId: "secret_6",
  //         cinematic: true,
  //         isEnd: true
  //       },
  //
  //     },
  //
  //   }
  // },

  {
    x: 2000,
    y: 1500,
    name: '"GOOD ENDING"',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'good_1',
      nodes: V2EndingNodes.GOOD_ENDING
    }
  },

  {
    x: 2200,
    y: 1500,
    name: 'BAD GAME OVER',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/glitter_small.gif', // Use NPC image
    dialogTree: {
      startDialogId: 'bad_1',
      nodes: V2EndingNodes.GAME_OVER_ENDING,
    }
  }
];

export default config;
